import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const EditVideoTutorialCategorySlice = createSlice({
    name: "EditVideoTutorialCategorySlice",
    initialState: {} as IReduxState<any>,
    reducers: {
        editVideoTutorialCategory: (state, action) => {
            state.isLoading = true;
        },
        successeditVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureeditVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearEditVideoTutorialCategoryResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    editVideoTutorialCategory,
    successeditVideoTutorialCategory,
    failureeditVideoTutorialCategory,
    clearEditVideoTutorialCategoryResponse,
} = EditVideoTutorialCategorySlice.actions;

export default EditVideoTutorialCategorySlice.reducer;
